import * as React from 'react';

import { PostfixPopupLink } from '@/packages/Filters/shared/components/Select';
import { useOfferType } from '@/packages/Filters/shared/utils/useOfferType';
import { isResidential as isResidentialFn } from '@/packages/JsonQuery';

export const DealTypePostfix: React.FC = () => {
  const offerType = useOfferType();
  const isResidential = isResidentialFn(offerType);

  if (!isResidential) {
    return null;
  }

  return (
    <PostfixPopupLink href="/country-builders-projects/?utm_medium=listing&utm_content=link" text="Построить дом" />
  );
};
